interface UnmappedLocationsBannerProps {
	count: number;
}

export const UnmappedLocationsBanner = ({
	count,
}: UnmappedLocationsBannerProps) => {
	if (count <= 0) return null;

	const noun = count === 1 ? "location isn’t" : "locations aren’t";

	return (
		<div
			className="bg-secondary_subtle absolute top-3 right-14 left-3 z-10 rounded-lg border border-secondary px-3 py-2 text-sm text-secondary shadow-sm md:right-auto md:max-w-md"
			role="status"
		>
			{count} {noun} shown on the map because they have no map position yet.
			Open them from the sidebar.
		</div>
	);
};
